import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '../../Icon';
import {
  UseInboxUnreadCount,
  useInboxUnreadCount,
} from 'src/SharedCustomHooks/UseInboxUnreadCount/useInboxUnreadCount';
import InboxRefreshIndicator from 'src/components/InboxRefreshIndicator/InboxRefreshIndicator';
import '../Navigation.scss';
import './inbox-link.scss';

export const InboxLink = ({ link, collapseSideBar }) => {
  const { unreadCount }: UseInboxUnreadCount = useInboxUnreadCount();

  return (
    <li
      title={link.label}
      className="navigation__link"
      key={`nav-link-${link.label}`}
    >
      <NavLink
        to={link.path}
        className={classNames('navigation__anchor', {
          'navigation__anchor--collapsed': collapseSideBar,
        })}
        activeClassName="navigation__anchor--active"
      >
        <FontAwesomeIcon weight="light" glyph={link.icon} />
        <div
          className={classNames('navigation__anchor--label', {
            'navigation__anchor--label--collapse': collapseSideBar,
          })}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            paddingRight: '1rem',
          }}
        >
          <span>{link.label}</span>
          {unreadCount > 0 && (
            <span className="inbox-unread-pill">
              <span className="inbox-unread-count">{unreadCount}</span>
              <InboxRefreshIndicator condensed />
            </span>
          )}
        </div>
      </NavLink>
    </li>
  );
};
